import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import type React from 'react'
import { useState } from 'react'
import { cn } from '@/frontend/utils'

export function Accordion({
  children,
  title,
  onToggle
}: {
  children: React.ReactNode
  title: React.ReactNode
  onToggle?: (open: boolean) => void
}) {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(!open)
    if (onToggle) onToggle(!open)
  }

  return (
    <Disclosure>
      <DisclosureButton onClick={handleClick} className='flex w-full items-center justify-between'>
        {title}
        <div className='flexitems-center'>
          <ChevronDownIcon
            className={cn('h-4 w-4 justify-self-end text-contentPrimary', open && 'hidden')}
          />
          <ChevronUpIcon
            className={cn('h-4 w-4 justify-self-end text-contentPrimary', !open && 'hidden')}
          />
        </div>
      </DisclosureButton>
      <DisclosurePanel className='py-2 text-contentPrimary'>{children}</DisclosurePanel>
    </Disclosure>
  )
}
